<template>
  <div class="main">
    <br v-if="tenant == 'sanjivani'" />

    <div style="display: flex">
      <div style="width: 30%; float: left">
        <img
          :src="person_details.rep_header.trust_logo"
          style="width: 150px"
          alt="logo"
        />
      </div>

      <div style="width: 70%; float: right">
        <br v-if="tenant != 'zeal'" />

        <h1 style="text-transform: uppercase; text-decoration: underline">
          {{ person_details.rep_header.school_name }}
        </h1>
        <h4 style="text-transform: uppercase" class="mdi mdi-map-marker">
          {{ person_details.rep_header.address }}
        </h4>
      </div>
    </div>

    <div align="center">
      <h2>
        Application Form for the Academic Year <u>{{ person_details.ay }}</u>
      </h2>
    </div>
    <br />
    <div class="personal_details">
      <div style="display: flex">
        <div style="width: 35%; float: left">
          <h3 style="margin: 10px">
            Admission Form No.:&nbsp;{{ person_details.admission_form_no }}
          </h3>
        </div>
        <div style="width: 75%; float: right">
          <div class="photo" v-if="person_details.parent_photo">
            <center>
              <v-img
                width="120"
                :src="awspath + person_details.parent_photo"
                aspect-ratio="1"
                class="grey lighten-2"
                style="border: 1px solid black"
              ></v-img>
              Parent's Photo
            </center>
          </div>
          <div class="photo">
            <center>
              <v-img
                width="120"
                :src="awspath + person_details.father_photo"
                aspect-ratio="1"
                class="lighten-2"
                style="border: 1px solid black"
              ></v-img>
              Father's Photo
            </center>
          </div>
          <div class="photo">
            <center>
              <v-img
                width="120"
                :src="awspath + person_details.mother_photo"
                aspect-ratio="1"
                class="lighten-2"
                style="border: 1px solid black"
              ></v-img>
              Mother's Photo
            </center>
          </div>
          <div class="photo">
            <center>
              <v-img
                width="120"
                :src="
                  awspath +
                  person_details.profile_image_path +
                  person_details.profile_image_name
                "
                aspect-ratio="1"
                class="lighten-2"
                style="border: 1px solid black"
              ></v-img>

              Student's Photo
            </center>
          </div>
        </div>
      </div>
    </div>
    <br v-if="tenant == 'sanjivani'" />

    <div class="personal_details">
      <v-row>
        <table style="width: 100%; margin-left: 2%">
          <caption>
            <b style="font-size: 22px"> Student Details </b>
          </caption>
          <br />
          <tr>
            <td style="width: 15%" v-if="person_details.firstname != null">
              <b> First Name</b>&nbsp;
            </td>
            <td style="width: 0%">:</td>
            <td
              style="text-decoration: underline; width: 14%"
              v-if="person_details.firstname != null"
            >
              {{ person_details.firstname.field_value }}
            </td>
            <td style="width: 8%" v-if="person_details.middlename != null">
              <b> Middle Name:</b>&nbsp;
            </td>
            <td
              style="text-decoration: underline; width: 14%"
              v-if="person_details.middlename != null"
            >
              {{ person_details.middlename.field_value }}
            </td>
            <td style="width: 7%" v-if="person_details.lastname != null">
              <b> Last Name:</b>&nbsp;
            </td>
            <td
              style="text-decoration: underline; width: 17%"
              v-if="person_details.lastname != null"
            >
              {{ person_details.lastname.field_value }}
            </td>
          </tr>
          <tr>
            <td v-if="person_details.fullname != null">
              <b> Full Name:</b>&nbsp;
            </td>
            <td
              style="text-decoration: underline"
              v-if="person_details.fullname != null"
            >
              {{ person_details.fullname.field_value }}
            </td>
          </tr>
        </table>

        <table style="width: 100%; margin-left: 2%">
          <tr>
            <td
              style="width: 20%"
              v-if="person_details.father_full_name != null"
            >
              <b> Father's Name:</b>&nbsp;
            </td>
            <td
              style="text-decoration: underline"
              v-if="person_details.father_full_name != null"
            >
              {{ person_details.father_full_name.field_value }}
            </td>
            <td
              style="width: 20%"
              v-if="person_details.mother_first_name != null"
            >
              <b> Mother's Name:</b>&nbsp;
            </td>
            <td
              style="text-decoration: underline"
              v-if="person_details.mother_first_name != null"
            >
              {{ person_details.mother_first_name.field_value }}
            </td>
          </tr>
        </table>
      </v-row>
      <v-row>
        <table style="width: 100%; margin-left: 2%; padding-bottom: 4px">
          <tr v-if="person_details.standard != null">
            <td style="width: 12%">
              <b> {{ person_details.standard.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.standard.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.gender != null">
            <td style="width: 14%">
              <b> {{ person_details.gender.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.gender.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.date_of_birth != null">
            <td style="width: 11%">
              <b> {{ person_details.date_of_birth.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.date_of_birth.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.date_of_birth_in_words != null">
            <td style="width: 11%">
              <b>
                {{
                  person_details.date_of_birth_in_words.field_display_name
                }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.date_of_birth_in_words.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.birth_place != null">
            <td style="width: 11%">
              <b> {{ person_details.birth_place.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.birth_place.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.nationality != null">
            <td style="width: 11%">
              <b> {{ person_details.nationality.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.nationality.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.religion != null">
            <td style="width: 11%">
              <b> {{ person_details.religion.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.religion.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.cast != null">
            <td style="width: 11%">
              <b> {{ person_details.cast.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.cast.field_value }}
            </td>
          </tr>

          <tr v-if="person_details.sub_caste != null">
            <td style="width: 11%">
              <b> {{ person_details.sub_caste.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.sub_caste.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.ration_card_color != null">
            <td style="width: 11%">
              <b> {{ person_details.ration_card_color.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.ration_card_color.field_value }}
            </td>
          </tr>

          <tr v-if="person_details.mothertoungue != null">
            <td style="width: 11%">
              <b> {{ person_details.mothertoungue.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.mothertoungue.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.category != null">
            <td style="width: 11%">
              <b> {{ person_details.category.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.category.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.bloodgroup != null">
            <td style="width: 11%">
              <b> {{ person_details.bloodgroup.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.bloodgroup.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.aadhar_no != null">
            <td style="width: 11%">
              <b> {{ person_details.aadhar_no.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.aadhar_no.field_value }}
            </td>
          </tr>
          <tr>
            <td style="width: 11%"><b> Primary Mobile No. </b>&nbsp;</td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.mobile_no }}
            </td>
          </tr>
          <tr>
            <td style="width: 20%"><b> Primary Email Id</b>&nbsp;</td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.personal_email }}
            </td>
          </tr>
          <tr v-if="person_details.family_type != null">
            <td style="width: 11%">
              <b> {{ person_details.family_type.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.family_type.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.languages_known != null">
            <td style="width: 11%">
              <b> {{ person_details.languages_known.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.languages_known.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.is_single_girl_child != null">
            <td style="width: 11%">
              <b>
                {{ person_details.is_single_girl_child.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.is_single_girl_child.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.is_EWS != null">
            <td style="width: 11%">
              <b> {{ person_details.is_EWS.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.is_EWS.field_value }}
            </td>
          </tr>

          <tr v-if="person_details.name_as_aadhar_card != null">
            <td style="width: 11%">
              <b> {{ person_details.name_as_aadhar_card.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.name_as_aadhar_card.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.udise_national_code != null">
            <td style="width: 11%">
              <b> {{ person_details.udise_national_code.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.udise_national_code.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.height_in_cm != null">
            <td style="width: 11%">
              <b> {{ person_details.height_in_cm.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.height_in_cm.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.weight_in_kg != null">
            <td style="width: 11%">
              <b> {{ person_details.weight_in_kg.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.weight_in_kg.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.hostel != null">
            <td style="width: 11%">
              <b> {{ person_details.hostel.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.hostel.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.reference != null">
            <td style="width: 11%">
              <b> {{ person_details.reference.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{ person_details.reference.field_value }}
            </td>
          </tr>
          <tr
            v-if="
              person_details.factors_contributed_for_admission_decision != null
            "
          >
            <td style="width: 11%">
              <b>
                {{
                  person_details.factors_contributed_for_admission_decision
                    .field_display_name
                }}</b
              >&nbsp;
            </td>
            <td style="width: 5%">:</td>
            <td style="text-decoration: underline">
              {{
                person_details.factors_contributed_for_admission_decision
                  .field_value
              }}
            </td>
          </tr>
        </table>
      </v-row>
    </div>
    <br />

    <div class="personal_details">
      <v-row>
        <table
          style="width: 100%; margin-left: 2%; padding-bottom: 4px"
          v-if="person_details.local_address != null"
        >
          <caption>
            <b style="font-size: 22px"> Local / Current Address </b>
          </caption>
          <tr>
            <td style="width: 11%"><b> Address</b></td>
            <td>:</td>
            <td>{{ person_details.local_address.laddress }}</td>
          </tr>
          <tr>
            <td style="width: 11%"><b> City</b></td>
            <td>:</td>
            <td>{{ person_details.local_address.lcity }}</td>
          </tr>
          <tr>
            <td style="width: 11%"><b> State</b></td>
            <td>:</td>
            <td>{{ person_details.local_address.lstate }}</td>
          </tr>
          <tr>
            <td style="width: 11%"><b> Country</b></td>
            <td>:</td>
            <td>{{ person_details.local_address.lcountry }}</td>
          </tr>
          <tr>
            <td style="width: 11%"><b> Pin</b></td>
            <td>:</td>
            <td>{{ person_details.local_address.lpin }}</td>
          </tr>
        </table>
        <table
          style="width: 100%; margin-left: 2%; padding-bottom: 4px"
          v-if="person_details.permanent_address != null"
        >
          <caption>
            <b style="font-size: 22px"> Permanent Address </b>
          </caption>
          <tr>
            <td style="width: 11%"><b> Address</b></td>
            <td>:</td>
            <td>{{ person_details.permanent_address.paddress }}</td>
          </tr>
          <tr>
            <td style="width: 11%"><b> City</b></td>
            <td>:</td>
            <td>{{ person_details.permanent_address.pcity }}</td>
          </tr>
          <tr>
            <td style="width: 11%"><b> State</b></td>
            <td>:</td>
            <td>{{ person_details.permanent_address.pstate }}</td>
          </tr>
          <tr>
            <td style="width: 11%"><b> Country</b></td>
            <td>:</td>
            <td>{{ person_details.permanent_address.pcountry }}</td>
          </tr>

          <tr>
            <td style="width: 11%"><b> Pin</b></td>
            <td>:</td>
            <td>{{ person_details.permanent_address.ppin }}</td>
          </tr>
        </table>
      </v-row>
    </div>
    <br />
    <v-row class="relative_details pagebreak">
      <br />
      <h1>&nbsp;</h1>

      <table
        class="personal_details"
        style="width: 100%; margin-left: 2%; padding-bottom: 4px"
      >
        <caption>
          <b style="font-size: 22px"> Previous School Attended </b>
        </caption>
        <tr v-if="person_details.previous_school_name != null">
          <td class="pl-2" style="width: 20%"><b> School Name</b>&nbsp;</td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.previous_school_name.field_value }}
          </td>
        </tr>
        <tr v-if="person_details.previous_school_address != null">
          <td class="pl-2" style="width: 20%"><b> School Address</b>&nbsp;</td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.previous_school_address.field_value }}
          </td>
        </tr>

        <tr v-if="person_details.previousschoolschoolboard != null">
          <td class="pl-2" style="width: 20%"><b> School Board</b>&nbsp;</td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.previousschoolschoolboard.field_value }}
          </td>
        </tr>
        <tr v-if="person_details.previous_school_obtained_percentage != null">
          <td class="pl-2" style="width: 20%">
            <b>
              {{
                person_details.previous_school_obtained_percentage
                  .field_display_name
              }}</b
            >&nbsp;
          </td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.previous_school_obtained_percentage.field_value }}
          </td>
        </tr>
        <tr v-if="person_details.no_of_years_in_previous_school != null">
          <td class="pl-2" style="width: 20%">
            <b> No. of years attended in the previous School</b>&nbsp;
          </td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.no_of_years_in_previous_school.field_value }}
          </td>
        </tr>
        <tr v-if="person_details.previousschoolpassingstandard != null">
          <td class="pl-2" style="width: 20%">
            <b>Last Grade Attended</b>&nbsp;
          </td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.previousschoolpassingstandard.field_value }}
          </td>
        </tr>
        <tr v-if="person_details.reason_for_leaving_last_school != null">
          <td class="pl-2" style="width: 20%">
            <b> Reason for leaving the School</b>&nbsp;
          </td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.reason_for_leaving_last_school.field_value }}
          </td>
        </tr>
        <tr v-if="person_details.date_of_leaving_previous_school != null">
          <td class="pl-2" style="width: 20%">
            <b> Date Of leaving Previous School</b>&nbsp;
          </td>
          <td>:</td>
          <td style="text-decoration: underline">
            {{ person_details.date_of_leaving_previous_school.field_value }}
          </td>
        </tr>
      </table>

      <br />

      <v-simple-table
        class="parent_details"
        style="width: 100%; margin-top: 15px; border-radius: 10px"
        id="page"
        v-if="person_details.relative_father_details != null"
      >
        <caption>
          <b style="font-size: 22px"> Parent Details </b>
        </caption>
        <!-- <thead> -->
        <tr>
          <th class="sib_table"></th>
          <th
            class="sib_table"
            v-if="person_details.relative_father_details != null"
          >
            <center>Father</center>
          </th>
          <th
            class="sib_table"
            v-if="person_details.relative_mother_details != null"
          >
            <center>Mother</center>
          </th>
        </tr>

        <tbody>
          <tr>
            <td class="sib_table"><b>Name</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_full_name }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_full_name }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Contact No.</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_contact_no }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_contact_no }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Email</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_email }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_email }}
            </td>
          </tr>

          <tr>
            <td class="sib_table"><b>Aadhar Card No.</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_aadharno }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_aadharno }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Nationality</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_nationality }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_nationality }}
            </td>
          </tr>

          <tr>
            <td class="sib_table"><b>Qualification</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_education }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_education }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Occupation</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_occupation }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_occupation }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Designation</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_designation }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_designation }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Organisation</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{
                person_details.relative_father_details
                  .relative_organization_name
              }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{
                person_details.relative_mother_details
                  .relative_organization_name
              }}
            </td>
          </tr>

          <tr>
            <td class="sib_table">
              <b>Organisation Address & Contact Details</b>
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{
                person_details.relative_father_details.relative_office_address
              }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{
                person_details.relative_mother_details.relative_office_address
              }}
            </td>
          </tr>

          <tr v-if="tenant != 'uwws'">
            <td class="sib_table"><b>Annual Income</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_father_details != null"
            >
              {{ person_details.relative_father_details.relative_income }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_mother_details != null"
            >
              {{ person_details.relative_mother_details.relative_income }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-simple-table
        style="width: 100%"
        id="page"
        class="sib_table"
        v-if="
          person_details.relative_brother_details != null &&
          person_details.relative_mother_details != null
        "
      >
        <caption>
          <b style="font-size: 22px"> Sibling Information </b>
        </caption>

        <tr>
          <th class="sib_table" style="font-size: 14px"></th>
          <th
            v-if="person_details.relative_brother_details != null"
            class="sib_table"
            style="font-size: 14px"
          >
            Brother
          </th>
          <th
            v-if="person_details.relative_sister_details != null"
            class="sib_table"
            style="font-size: 14px"
          >
            Sister
          </th>
        </tr>

        <tbody>
          <tr>
            <td class="sib_table"><b>Name</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_full_name }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_full_name }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Aadhar No</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_aadharno }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_aadharno }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Education</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_education }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_education }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Annual Income</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_income }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_income }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Email</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_email }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_email }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Organisation</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{
                person_details.relative_brother_details
                  .relative_organization_name
              }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{
                person_details.relative_sister_details
                  .relative_organization_name
              }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Designation</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_designation }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_designation }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Office Address</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{
                person_details.relative_brother_details.relative_office_address
              }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{
                person_details.relative_sister_details.relative_office_address
              }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Contact No</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_contact_no }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_contact_no }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Nationality</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_nationality }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_nationality }}
            </td>
          </tr>
          <tr>
            <td class="sib_table"><b>Occupation</b></td>
            <td
              class="sib_table"
              v-if="person_details.relative_brother_details != null"
            >
              {{ person_details.relative_brother_details.relative_occupation }}
            </td>
            <td
              class="sib_table"
              v-if="person_details.relative_sister_details != null"
            >
              {{ person_details.relative_sister_details.relative_occupation }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-row>

    <br />
    <div class="personal_details">
      <v-row class="contact_details">
        <table style="width: 100%; margin-left: 2%; padding-bottom: 4px">
          <caption>
            <b style="font-size: 22px">
              Guardian Details - To be contacted in case of any emergency. [Note
              - Other than Parent]
            </b>
          </caption>
          <br />
          <tr v-if="person_details.emergency_contact_name != null">
            <td style="width: 14%"><b> Name</b>&nbsp;</td>
            <td>:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.emergency_contact_name.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.emergency_contact_number != null">
            <td style="width: 14%"><b> Contact No.</b>&nbsp;</td>
            <td>:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.emergency_contact_number.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.emergency_email != null">
            <td style="width: 14%"><b>Email</b>&nbsp;</td>
            <td>:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.emergency_email.field_value }}
            </td>
          </tr>

          <tr v-if="person_details.emergency_contact_address != null">
            <td style="width: 14%"><b> Address</b>&nbsp;</td>
            <td>:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.emergency_contact_address.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.emergency_relation != null">
            <td style="width: 14%"><b>Relationship with the child</b>&nbsp;</td>
            <td>:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.emergency_relation.field_value }}
            </td>
          </tr>
        </table>
      </v-row>
    </div>
    <br />
    <div class="personal_details" v-if="tenant != 'uwws'">
      <v-row
        class="medical_details"
        v-if="person_details.medical_problem != null"
      >
        <table style="width: 100%; margin-left: 2%; padding-bottom: 4px">
          <caption>
            <b style="font-size: 22px"> Medical Details </b>
          </caption>
          <br />
          <tr v-if="person_details.medical_problem != null">
            <td style="width: 7%">
              <b> Any medical ailment of child that we need to know about</b
              >&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.medical_problem.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.isphysicallyhandicapped != null">
            <td style="width: 7%">
              <b>
                {{
                  person_details.isphysicallyhandicapped.field_display_name
                }}</b
              >&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.isphysicallyhandicapped.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.physicallyhandicapped_details != null">
            <td style="width: 7%">
              <b>{{
                person_details.physicallyhandicapped_details.field_display_name
              }}</b
              >&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{
                person_details.emergephysicallyhandicapped_detailsncy_email
                  .field_value
              }}
            </td>
          </tr>

          <tr v-if="person_details.allergy != null">
            <td style="width: 7%">
              <b> {{ person_details.allergy.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.allergy.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.medication != null">
            <td style="width: 7%">
              <b>{{ person_details.medication.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.medication.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.vacination != null">
            <td style="width: 7%">
              <b>{{ person_details.vacination.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.vacination.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.foods_to_be_avoided != null">
            <td style="width: 7%">
              <b>{{ person_details.foods_to_be_avoided.field_display_name }}</b
              >&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.foods_to_be_avoided.field_value }}
            </td>
          </tr>
        </table>
      </v-row>
    </div>
    <br />
    <div class="personal_details">
      <v-row>
        <table style="width: 100%; margin-left: 2%; padding-bottom: 4px">
          <caption>
            <b style="font-size: 22px"> Transport Details </b>
          </caption>
          <br />
          <tr v-if="person_details.is_transport_facility_needed != null">
            <td style="width: 4%">
              <b> Is transport facility needed</b>&nbsp;
            </td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.is_transport_facility_needed.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.transport_declaration != null">
            <td style="width: 4%"><b> Transport declaration</b>&nbsp;</td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.transport_declaration.field_value }}
            </td>
          </tr>
          <tr v-if="person_details.transport_drop_point != null">
            <td style="width: 4%"><b>Transport drop point</b>&nbsp;</td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.transport_drop_point.field_value }}
            </td>
          </tr>

          <tr v-if="person_details.transport_boarding_point != null">
            <td style="width: 4%"><b>Transport boarding point</b>&nbsp;</td>
            <td style="width: 2%">:</td>
            <td style="text-decoration: underline; width: 15%">
              {{ person_details.transport_boarding_point.field_value }}
            </td>
          </tr>
        </table>
      </v-row>
    </div>
    <br />
    <v-row v-if="person_details.sibling1 != null">
      <!-- shiv simple table -->
      <v-simple-table style="width: 100%" id="page" class="pagebreak mt-5">
        <caption>
          <b style="font-size: 22px"> Sibling Details </b>
        </caption>

        <tr>
          <th class="sib_table" style="font-size: 14px">
            <center>Sr. No.</center>
          </th>
          <th class="sib_table" style="font-size: 14px">
            <center>Name</center>
          </th>
          <th class="sib_table" style="font-size: 14px">
            <center>School</center>
          </th>
          <th class="sib_table" style="font-size: 14px">
            <center>D.O.B</center>
          </th>
          <th class="sib_table" style="font-size: 14px">
            <center>Relation</center>
          </th>
          <th class="sib_table" style="font-size: 14px">
            <center>Grade</center>
          </th>
        </tr>

        <tbody>
          <tr>
            <td class="sib_table">1</td>
            <td class="sib_table">
              {{ person_details.sibling1.sibling_name }}
            </td>
            <td class="sib_table">
              {{ person_details.sibling1.name_of_school }}
            </td>
            <td class="sib_table">
              {{ person_details.sibling1.date_of_birth }}
            </td>
            <td class="sib_table">
              {{ person_details.sibling1.relationtype }}
            </td>
            <td class="sib_table">{{ person_details.sibling1.standard }}</td>
          </tr>

          <tr>
            <td class="sib_table">2</td>
            <td class="sib_table">
              {{ person_details.sibling2.sibling_name }}
            </td>
            <td class="sib_table">
              {{ person_details.sibling2.name_of_school }}
            </td>
            <td class="sib_table">
              {{ person_details.sibling2.date_of_birth }}
            </td>
            <td class="sib_table">
              {{ person_details.sibling2.relationtype }}
            </td>
            <td class="sib_table">{{ person_details.sibling2.standard }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <!-- shiv simple table end -->
    </v-row>
    <br />

    <div v-if="tenant == 'sanjivani'" class="pagebreak declaration_details">
      <v-row v-if="person_details.admission_instruction != null">
        <v-col
          v-if="
            person_details.admission_instruction
              .admission_instructions_html_code != null
          "
        >
          <div
            v-html="
              person_details.admission_instruction
                .admission_instructions_html_code
            "
          ></div>
        </v-col>
        <v-col
          v-if="
            person_details.admission_instruction
              .admission_checklist_html_code != null
          "
        >
          <div
            v-html="
              person_details.admission_instruction.admission_checklist_html_code
            "
          ></div>
        </v-col>
      </v-row>
    </div>

    <div class="container">
      <div class="text-center">
        <v-btn
          class="ma-2 no-display"
          tile
          outlined
          color="warning"
          @click="print()"
          v-if="person_details != null"
        >
          <v-icon left>mdi-printer</v-icon>Print
          <v-icon right></v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["person_details"],
  created() {
    this.awspath = localStorage.getItem("awspath");
    this.tenant = localStorage.getItem("EPS-tenant");
    console.log("sanjivani");
  },
  methods: {
    print() {
      setTimeout(function () {
        window.print();
      }, 100);
    },
  },
};
</script>

<style scoped>
.medical_details {
  margin-left: 3px;
}
td,
tr {
  font-weight: bold;
  font-size: 16px;
}
.main {
  margin-left: 1%;
  margin-right: 1%;
}
#page {
  margin-right: 1%;
  margin-left: 1%;
}
@media print {
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .pagebreak {
    page-break-before: always;
  }

  header,
  footer,
  nav,
  date {
    display: none !important;
  }
}
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* shiv css  */
.personal_details {
  border: 2px solid black;
  border-radius: 20px;
  padding-bottom: 5px;
}

.sib_table {
  text-align: left;
  border: 1px solid black;

  border-collapse: collapse;
}

.photo {
  margin: 10px;
  margin-top: 15px;
  margin-right: 15px;
  float: right;
}

@page {
  size: A4;
  margin-top: none;
  padding-top: none;
  /* size: 15in 15.5in; */
  size: 11.5in 16.5in;
}
@page :first {
  margin-top: 40px;
}

th:first-of-type {
  border-top-left-radius: 20px;
}

th:last-of-type {
  border-top-right-radius: 20px;
}

tr:last-of-type td:first-of-type {
  border-bottom-left-radius: 20px;
}

tr:last-of-type td:last-of-type {
  border-bottom-right-radius: 20px;
}

.declaration_details {
  font-size: larger;
}

.parent_details td,
tr,
th {
  font-size: 16px !important;
}

/* shiv css end */
</style>
